// IMPORT LIBS
import jQuery from 'jquery';
import Swiper from 'swiper';
import noUiSlider from 'nouislider';
import bootstrapBundle from '../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import wNumb from "wnumb";
import "regenerator-runtime/runtime";
import './functions/favorites';

window.$ = jQuery;
window.jQuery = jQuery;
window.Swiper = Swiper;
window.noUiSlider = noUiSlider;
window.bootstrapBundle = bootstrapBundle;

// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
window.fancybox = fancybox;

// IMPORT CLASSES
// import Used from './classes/Used'; 

// IMPORT FUNCTIONS
import { tabsCreate, tabsInit } from './functions/tabs';
import { swipersInit } from './functions/sliders';
import { accordionsCreate, controlAccordionsFilter } from './functions/accordions';
import { showPartialsFixed } from './functions/partialsFixed';
import { buttonCotationBehavior, buttonFilterBehavior, buttonFavoriteBehavior, wrapInputWithContainer } from './functions/actionsForm';
import { sidebarFixedBehavior } from './functions/sidebarFixed';
import { controlDate } from './functions/controlDate';
import { redirectPage } from './functions/redirectPage';
import { handleSetMoreHeight } from './functions/setHeights';
import { sidebarFloatingBehavior } from './functions/sidebarFloating';
import { uploadFiles } from './functions/uploadFiles';
import { chooseUnits } from './functions/chooseLocation';

document.addEventListener('DOMContentLoaded', function() {

  // INIT LAZY LOADING
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  // FUNCTIONS TO CREATE AND INIT TABS
  tabsCreate();
  tabsInit();

  // FUNCTION TO CREATE AND INIT ACCORDIONS
  accordionsCreate();

  // FUNCTION TO INIT CHOOSE LOCATION
  chooseUnits();

  // FUNCTION TO CREATE AND INIT SWIPERS
  swipersInit(); 

  const pagename = document.getElementById('pagename').innerText;

  // FUNCTION TO CONTROL ACCORDIONS ON USED CARS FILTER
  // controlAccordionsFilter();

  // FUNCTION TO CONTROL HEADER/FOOTER FIXED
  window.addEventListener('scroll', () => {
    showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
    showPartialsFixed('.footer-fixed', 'show-footer-scrolled', 'hide-footer-scrolled');
    showPartialsFixed('.header-mobile.fixed', 'show-header-scrolled', 'hide-header-scrolled');

    showPartialsFixed('.header-fixed-audi', 'show-header-scrolled', 'hide-header-scrolled');
    showPartialsFixed('.header-mobile-audi', 'show-header-scrolled', 'hide-header-scrolled');
    showPartialsFixed('.header-mobile-audi.fixed', 'show-header-scrolled', 'hide-header-scrolled');
  });

  // FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
  buttonCotationBehavior('.button-call-form');
  buttonCotationBehavior('.button-product-cotation');

  // FUNCTION TO CONTROL BEHAVIOR OF FILTERS BUTTONS
  buttonFilterBehavior('.button-call-filter');

    // FUNCTION TO CONTROL BEHAVIOR OF FAVORITE BUTTONS
    buttonFavoriteBehavior('.button-call-favorite');
  

  // FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FIXED
  sidebarFixedBehavior('.js-sidebar-button');

  // FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FLOATING
  sidebarFloatingBehavior('.js-menu-header');

  // FUNCTION TO INSERT CURRENT DATE IN INPUTS [TYPE=DATE]
  controlDate('input[type="date"]');

  // FUNCTION TO CONTROL UPLOADS OF FILES
  uploadFiles('.input-upload', '.label-wrapper-image img', '.upload-wrapper-close');

  // FUNCTION TO REDIRECT TO HOME PAGE
  redirectPage();

  setTimeout(() => {
    // FUNCTION TO SET MORE HEIGHT AMONG THE ELEMENTS OF SAME TYPE
    handleSetMoreHeight('.js-high-title', 992);
    handleSetMoreHeight('.js-high-desc', 992);
    handleSetMoreHeight('.js-blog-title', 992);
    handleSetMoreHeight('.js-blog-desc', 992);

  }, 500);

  setFamily();
  getModelFromParams();
  changeTestDriveImage();

  function validateReceiveContact() {
    let checkBoxes = document.querySelectorAll('.input-receive-contact');
    let submitButtons = document.querySelectorAll('.alpes-forms button[type="submit"]');
    let noCheckedBoxes = true;
  
    function updateSubmitButton() {
      noCheckedBoxes = Array.from(checkBoxes).every(checkbox => !checkbox.checked);
  
      submitButtons.forEach(btn => {
        if (noCheckedBoxes) {
          btn.setAttribute('disabled', 'disabled');
          btn.classList.add('disabled');
          btn.setAttribute('title', 'Preencha todos os campos solicitados');
        } else {
          btn.removeAttribute('disabled');
          btn.classList.remove('disabled');
          btn.removeAttribute('title');
        }
      });
    }
  
    checkBoxes.forEach(checkbox => {
      checkbox.addEventListener('change', updateSubmitButton);
    });

    updateSubmitButton();
  }
  
  validateReceiveContact(); 

  
  //   const usedFilterData = document.querySelector('#used-filter-data');

  //   if (usedFilterData) {
  //     const dataFilter = usedFilterData.getAttribute('data-filter');
  //     const filters = JSON.parse(dataFilter);
  //     new Used(filters);
  //   }


  $('#categories,#order').on('change', function (event) { // catch the form's submit event
    $.ajax({ // create an AJAX call...

        data: $('#formBlog').serialize(), // get the form data
        type: $(this).attr('GET'), // GET or POST
        url: "/blog-post-page", // the file to call
        success: function (response) { // on success..
          $('#here').html(response); // update the DIV
          const observer = lozad(); // lazy loads elements with default selector as '.lozad'
          observer.observe();
          handleSetMoreHeight('.js-blog-title', 992);
          handleSetMoreHeight('.js-blog-desc', 992);
        }
    });
    return false; // cancel original event to prevent form submitting
  });

  
});

function tryFindPriceKmInput() {
  const priceKmElements = [];
  priceKmElements.push(...document.querySelectorAll('#price_min_masked'));
  priceKmElements.push(...document.querySelectorAll('#price_max_masked'));
  priceKmElements.push(...document.querySelectorAll('#km_min_masked'));
  priceKmElements.push(...document.querySelectorAll('#km_max_masked'));

  if (priceKmElements.length > 1) {
    wrapInputWithContainer('price_min_masked', 'price');
    wrapInputWithContainer('price_max_masked', 'price');
    wrapInputWithContainer('km_min_masked', 'km');
    wrapInputWithContainer('km_max_masked', 'km');
  }
}

function handleRequestCompleted() {
  tryFindPriceKmInput(); 
}

window.addEventListener('onLoadFilters', handleRequestCompleted);

// const selectElement = document.getElementById('carsCategories');
// if (selectElement) {
//   const intervalId = setInterval(addCategoryToHomeFilter, 1000);

//   function addCategoryToHomeFilter() {
//     const options = selectElement.getElementsByTagName('option');

//     if (options.length > 1) {
//       clearInterval(intervalId);
//       const newOption = document.createElement('option');
//       newOption.value = "utilitario";
//       newOption.text = "7 Lugares";
//       selectElement.appendChild(newOption);
//     }
//   }
// }

function setFamily(){
  let searchParams = new URLSearchParams(window.location.search);
  const modelname = searchParams.get('modelname');
  const selector = ".my-tabs[data-content='"+modelname+"']";
}

function getModelFromParams() {
  let searchParams = new URLSearchParams(window.location.search);
  const modelname = searchParams.get('modelname');

  if (modelname) {
    $('select#model').val(modelname);
    const imgWrapper = $('form .test-drive-form-img img');

    const img = $('select#model').find('option:selected').attr('data-image');
    imgWrapper.attr('src', img);
  }
}

function changeTestDriveImage() {
  const myInput = $('select#model');
  const imgWrapper = $('form .test-drive-form-img img');
  myInput.on('change', function (e) {
    const img = $(e.target).find('option:selected').attr('data-image');
    imgWrapper.attr('src', img);
  });
}

// FUNCTION TO UP TOP PAGE
$('.btn-scroll-top').on('click', function () {
  $('html,body').animate({ scrollTop: 0 }, '300')
});

// FUNCTION TO ADD OVERLAY ON MODALS
function popUp(selector) {
  $('body,html').addClass('scroll-lock');
  selector.fadeIn('fast');
}

function popClose(form) {
  form ? $('.modal-form').fadeOut() : $('.modal-overlay').fadeOut();
  $('body,html').removeClass('scroll-lock');
}

// FUNCTION TO PASS INFORMATION TO POP-UP PROMOTIONS
function modalInject(data, target) {
  const { title, img, text } = data;
  $(target).find('.promotion-title').html(title);
  $(target).find('.promotion-img').attr('src', img);
  $(target).find('.promotion-text').html(text);
  popUp($(target));
}

$('.btn-open-modal').on('click', function () {
  const el = $(this).data('target');
  const data = $(this).data('json');
  data ? modalInject(data, el) : popUp($(el));
})

// FUNCTION TO OPEN MODALS
$('.modal-overlay, .btn-close-modal').on('click', function (e) {
  $(e.target).hasClass('modal-close') ? popClose() : false
}).on('click', '.pop-up-content', function (event) {
  event.stopPropagation()
})

// FUNCTION TO CONTROL PAGINATIONS
let currentPage = 1;
let currentOrd = 'asc';
let order = 'id';

$('.order-control').on('click', function () {
  search(currentPage);
});

$('.page-link').on('click', function () {

  currentPage = $(this).data('page');
  $('.page-link').removeClass("active");
  $(this).addClass("active");
  search(currentPage);
});

$('.page-link').on('click', function () {
  currentPage = $(this).data('page');
  $('.page-item').removeClass("active");
  $(this.parentElement).addClass("active");

  if (currentPage != "1") {
    $('.left-arrow').removeClass("disabled");
  } else {
    $('.left-arrow').addClass("disabled");
  }

  search(currentPage);
});

function search(pageNum = 1) {
  async function busca() {
    currentOrd = $("#order").val();
    let method = $("#pageId").val();

    if(!order){
    order = 'id'
    }

    if(!currentOrd){
    currentOrd = 'asc'
    }

    if(method == 'products'){
      const result = await $.request('onGetProducts', {
      data: {order: order,direction : currentOrd, page: pageNum, limit: 1},
      complete: function(res) {
        const observer = lozad(); // lazy loads elements with default selector as '.lozad'
        observer.observe();
      }
      });
      return result;
    }

      if(method == 'promotions'){
        console.log('promtions')
        const result = await $.request('onGetPromotions', {
        data: {order: currentOrd,page: pageNum, limit: 1},
        complete: function(res) {
          const observer = lozad(); // lazy loads elements with default selector as '.lozad'
          observer.observe();
        }
        });
        return result;
      }

  }

  let a = busca().then( data => $("#promotions").html(data.result)).finally(
    function () {
      buttonCotationBehavior('.button-product-cotation');

      $('.btn-open-modal').on('click', function () {
        const el = $(this).data('target');
        const data = $(this).data('json');
        data ? modalInject(data, el) : popUp($(el));
      });

      $('.page-item').on('click', function () {
        const data = $(this).find('[data-page]').data('page')
        search(data);
      });
    }
  );
}

// NOUISLIDER OF PRICE IN FILTER OF HEADER
const sliderPrice = document.querySelector('#slider-price');

if(window.innerWidth >= 992 && sliderPrice && (window.location.pathname != '/seminovos' && window.location.pathname != '/outlet45dias' && window.location.pathname != '/seminovos-premium' )) {

  let curPrefix = sliderPrice.dataset.prefix;
  let curSuffix = sliderPrice.dataset.suffix;
  let curStep = Number(sliderPrice.dataset.step);
  let curMinPrice = Number(sliderPrice.dataset.min);
  let curMaxPrice = Number(sliderPrice.dataset.max);

  const sliderFormat = wNumb({
    decimals: 0,
    thousand: '.',
    prefix: curPrefix,
    suffix: curSuffix
  });

  noUiSlider.create(sliderPrice, {
    connect: true,
    step: curStep,
    start: [curMinPrice, curMaxPrice],
    range: {
        'min': [curMinPrice],
        'max': [curMaxPrice]
    },
    format: sliderFormat,
  });

  const nodesPrice = [
    sliderPrice.parentElement.querySelector('.min-value'),
    sliderPrice.parentElement.querySelector('.max-value')
  ];

  const inputsPrice = [ 
    sliderPrice.parentElement.querySelector('input[name$=_min]'),
    sliderPrice.parentElement.querySelector('input[name$=_max]'),
  ];


  sliderPrice.noUiSlider.on('update', (values, handle) => {
    nodesPrice[handle].innerHTML = values[handle];
    inputsPrice[handle].value = values[handle].replace('R$ ', '').replace('.', '');
  });
}



